import { render, staticRenderFns } from "./BatchesDataTable.vue?vue&type=template&id=55d3acd2"
import script from "./BatchesDataTable.vue?vue&type=script&lang=js"
export * from "./BatchesDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports